<template>
<VueSlickgrid
  :name="gridName"
  :headerTitle="messages.title"
  :items="ds"
  checkbox-row-selection
  export-to-csv
  :exportToCsvFilename="messages.exportFilename"
  footer-totals
  :columnDefaults="b_7315092382398562_columnDefaults"
  :columns="b_7315092382398562_columns"
  ref="grid"
  @selectedRowsChanged="evh_7315092382398562_selectedRowsChanged($event, {})"
  @command="evh_7315092382398562_command($event, {})"
>
  <DIV
    class="flex-grow-1 d-flex border-left px-3"
    slot="toolbar"
  >
    <b-dropdown
      size="sm"
      toggle-class="btn-light border"
    >
      <template
        slot="button-content"
      >
        <ItpIcon
          :icon="$config.billingList.createItemIcon"
          class="mx-1"
        >
        </ItpIcon>
        <ItpText
          :text="'Billing plan'|pgettext('billingList')"
        >
        </ItpText>
      </template>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Create billing plan...'|pgettext('BillingList')"
        size="sm"
        dropdown-item
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Add item...'|pgettext('BillingList')"
        size="sm"
        dropdown-item
        @click="evh_6705964765214521_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Copy items...'|pgettext('BillingList')"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        dropdown-item
        @click="evh_6806515264385235_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        icon="fa-trash"
        :text="'Delete'|gettext"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        dropdown-item
        @click="evh_8116269939469002_click($event, {})"
      >
      </ItpNavItem>
      <ItpNavItem
        :icon="$config.billingList.createItemIcon"
        :text="'Bulk edit...'|pgettext('billingList')"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        dropdown-item
        @click="evh_5900129514656303_click($event, {})"
      >
      </ItpNavItem>
    </b-dropdown>
    <JobHandlerControl
      size="sm"
      jobType="invoice_generation_from_billing_list"
      load-current
      :payload="onCreateInvoicesPayload"
      icon="mdi:cog"
      :text="'Generate invoices'|pgettext('BillingList|Submit')"
      :disabled="!selectedItems || !selectedItems.length"
      class="ml-3"
      @success="evh_3343864469950044_success($event, {})"
    >
    </JobHandlerControl>
    <ItpButton
      icon="fa-trash"
      :text="'Delete invoices'|gettext"
      size="sm"
      variant="light"
      :disabled="!selectedItems || !selectedItems.length"
      :spinning="actions.deleteInvoices.isRunning"
      class="ml-3"
      @click="evh_1889980785424776_click($event, {})"
    >
    </ItpButton>
    <ArtifactJob
      icon="ic:baseline-download"
      :text="'Download views'|gettext"
      size="sm"
      :disabled="!selectedItems || !selectedItems.length"
      operation="download_invoice_views"
      :payload="boundDownloadViewsPayloadMethod()"
      class="ml-3"
    >
    </ArtifactJob>
  </DIV>
</VueSlickgrid>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcBillingList extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getQueryParameters(...args: any[]) {
    return {
      company_id: this.companyId,
      client_id: this.clientId,
      rental_id: this.rentalId,
      contract_id: this.contractId,
    }
  }

  onCreateInvoicesPayload(...args: any[]) {
    return {
      items: this.selectedItems.map(p => ({ id: p.id }))
    };

    return this.$imodal
      .show({ name: 'CompleteInvoicesAlt' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          ...result.value,
          invoice_id: p.id,
        }));
      }
      )
  }

  onCreateBillingPlan(...args: any[]) {
    return {
      items: this.selectedItems.map(p => ({ id: p.id }))
    };

    return this.$imodal
      .show({ name: 'CreateBillingPlan' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          ...result.value,
          invoice_id: p.id,
        }));
      }
      )
  }

  getDownloadViewsPayload(...args: any[]) {
    return {
      identities: _.chain(this.selectedItems)
        .filter(p => p.invoice && p.invoice.id)
        .map(p => p.invoice.id)
        .uniq()
        .value()
    }
  }

  boundDownloadViewsPayloadMethod(...args: any[]) {
    if (!this._getDownloadViewsPayload) {
      this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
    }
    return this._getDownloadViewsPayload
  }

  @Prop({
    type: String,
  })
  companyId!: string;

  @Watch('companyId')
  onCompany_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("companyId")
  }

  @Prop({
    type: String,
  })
  clientId!: string;

  @Watch('clientId')
  onClient_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("clientId")
  }

  @Prop({
    type: String,
  })
  rentalId!: string;

  @Watch('rentalId')
  onRental_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rentalId")
  }

  @Prop({
    type: String,
  })
  contractId!: string;

  @Watch('contractId')
  onContract_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contractId")
  }

  gridName!: any;
  messages!: any;
  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_billing_list_item', { parameters: this.getQueryParameters })
  }

  ux!: any;
  b_7315092382398562_columnDefaults!: any;
  b_7315092382398562_columns!: any;
  dataMembers = ['gridName', 'messages', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "billingList",
        messages: {
          title: this.$fn.pgettext("billingList|Title", "Billing list"),
          exportFilename: this.$fn.pgettext("billingList|Export|Filename", "billing-list"),
        }
        ,
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_7315092382398562_columns: [{
          field: "invoice_date",
          name: this.$fn.pgettext("BillingList", "Billing due date"),
          type: "date",
        }
          ,
        {
          field: "invoice",
          name: this.$fn.pgettext("BillingList", "Invoice"),
          params: {
            sortPath: "invoice.invoice_number",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "due_date",
          name: this.$fn.pgettext("BillingList", "Payment due date"),
          type: "date",
        }
          ,
        {
          name: this.$fn.pgettext("BillingList", "Period start"),
          params: {
            sortPath: "period.start",
          }
          ,
          field: "period.start",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "period.start",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          name: this.$fn.pgettext("BillingList", "Period end"),
          params: {
            sortPath: "period.end",
          }
          ,
          field: "period.end",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "period.end",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "company",
          name: this.$fn.pgettext("BillingList", "Company"),
          width: "100px",
          params: {
            sortPath: "company.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "company.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "partner",
          name: this.$fn.pgettext("BillingList", "Partner"),
          width: "100px",
          params: {
            sortPath: "partner.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "partner.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "contract",
          name: this.$fn.pgettext("BillingList", "Contract"),
          params: {
            sortPath: "contract.contract_number",
          }
          ,
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.contract_number }}\">{{ $value.contract_number }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              params: {
                id: "contract.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("BillingList", "Description"),
          type: "command",
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("BillingList", "Billing category"),
        }
          ,
        {
          field: "notes",
          name: this.$fn.pgettext("BillingList", "Notes"),
        }
          ,
        {
          field: "quantity",
          name: this.$fn.pgettext("BillingList", "Quantity"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "unit",
          name: this.$fn.pgettext("BillingList", "Unit"),
        }
          ,
        {
          field: "unit_price",
          name: this.$fn.pgettext("BillingList", "Price"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "currency",
          name: this.$fn.pgettext("BillingList", "Currency"),
        }
          ,
        {
          field: "discount",
          name: this.$fn.pgettext("BillingList", "Discount"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "net_amount",
          name: this.$fn.pgettext("BillingList", "Net"),
          type: "number",
          formatter: "number",
        }
          ,
        {
          field: "tax_code",
          name: this.$fn.pgettext("BillingList", "Tax code"),
        }
          ,
        {
          field: "exchange_rate",
          name: this.$fn.pgettext("BillingList", "Exchrate"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <span title=\"{{ $value.value }}\">{{ $value.value }}</span>\n\
\n\
    {{~#if $value.date }}\n\
      <span>&middot; {{ $value.date }}</span>\n\
    {{~/if }}\n\
\n\
    {{~#if $value.source }}\n\
      <span>&middot; {{ $value.source }}</span>\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "intermediated_service",
          name: this.$fn.pgettext("BillingList", "Intermediated Service"),
          formatter: "checkmark",
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  async act_7315092382398562_setData_2112_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7315092382398562_setData_2112, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_7315092382398562_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_7315092382398562_showModal_2114_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7315092382398562_showModal_2114, alias=undefined
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.invoice.id,
        modal: true,
      }
      ,
    }
  }

  async evh_7315092382398562_command_2113_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_command_2113, alias=undefined
    return $event.data.column.id === 'invoice'
  }

  async act_7315092382398562_reloadSlickgrid_2118_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_7315092382398562_reloadSlickgrid_2118, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_7315092382398562_close_2117_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_close_2117, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_7315092382398562_showModal_2116_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7315092382398562_showModal_2116, alias=undefined
    return {
      name: "BillingListItem",
      props: {
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_7315092382398562_command_2115_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_command_2115, alias=undefined
    return $event.data.column.id === 'description'
  }

  async evh_7315092382398562_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_command.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_reloadSlickgrid_2122_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8320016629450276_reloadSlickgrid_2122, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_8320016629450276_close_2121_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_2121, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_8320016629450276_showModal_2120_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_2120, alias=undefined
    return {
      name: "CreateBillingPlan",
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_reloadSlickgrid_2126_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6705964765214521_reloadSlickgrid_2126, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_6705964765214521_close_2125_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6705964765214521_close_2125, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_6705964765214521_showModal_2124_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6705964765214521_showModal_2124, alias=undefined
    return {
      name: "BillingListItem",
    }
  }

  async evh_6705964765214521_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
  }

  async act_6806515264385235_reloadSlickgrid_2130_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6806515264385235_reloadSlickgrid_2130, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_6806515264385235_close_2129_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6806515264385235_close_2129, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_6806515264385235_showModal_2128_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6806515264385235_showModal_2128, alias=undefined
    return {
      name: "CopyBillingListItems",
      props: {
        sources: _.map(this.selectedItems, 'id'),
      }
      ,
    }
  }

  async evh_6806515264385235_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6806515264385235_click.executeFromDOM(this, event, scope);
  }

  async act_8116269939469002_reloadSlickgrid_2134_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8116269939469002_reloadSlickgrid_2134, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_8116269939469002_request_2132_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8116269939469002_request_2132, alias=deleteItems
    return {
      operation: "delete_many_billing_list_item",
      data: { items: this.selectedItems.map(p => p.id) },
    }
  }

  async evh_8116269939469002_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8116269939469002_click.executeFromDOM(this, event, scope);
  }

  async act_5900129514656303_reloadSlickgrid_2138_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_5900129514656303_reloadSlickgrid_2138, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_5900129514656303_close_2137_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_5900129514656303_close_2137, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_5900129514656303_showModal_2136_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5900129514656303_showModal_2136, alias=undefined
    return {
      name: "BatchBillingListEditor",
      props: {
        items: this.selectedItems,
      }
      ,
    }
  }

  async evh_5900129514656303_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5900129514656303_click.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_reloadSlickgrid_2140_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3343864469950044_reloadSlickgrid_2140, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_3343864469950044_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_success.executeFromDOM(this, event, scope);
  }

  async act_1889980785424776_reloadSlickgrid_2144_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1889980785424776_reloadSlickgrid_2144, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_1889980785424776_request_2142_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1889980785424776_request_2142, alias=deleteInvoices
    return {
      operation: "delete_draft_invoices",
      data: {
        invoices: _.chain(this.selectedItems)
          .filter(p => _.get(p, 'invoice.id') != null)
          .map(p => p.invoice.id)
          .uniq()
          .value()
      },
    }
  }

  async evh_1889980785424776_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1889980785424776_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_setData_2112: actions.SetDataAction;
    evh_7315092382398562_selectedRowsChanged_2111: actions.EventHandlerImpl;
    evh_7315092382398562_selectedRowsChanged: actions.EventHandlerGroup;
    act_7315092382398562_showModal_2114: actions.ShowModalAction;
    evh_7315092382398562_command_2113: actions.EventHandlerImpl;
    act_7315092382398562_reloadSlickgrid_2118: actions.ReloadSlickgridAction;
    evh_7315092382398562_close_2117: actions.EventHandlerImpl;
    act_7315092382398562_showModal_2116: actions.ShowModalAction;
    evh_7315092382398562_command_2115: actions.EventHandlerImpl;
    evh_7315092382398562_command: actions.EventHandlerGroup;
    act_8320016629450276_reloadSlickgrid_2122: actions.ReloadSlickgridAction;
    evh_8320016629450276_close_2121: actions.EventHandlerImpl;
    act_8320016629450276_showModal_2120: actions.ShowModalAction;
    evh_8320016629450276_click_2119: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
    act_6705964765214521_reloadSlickgrid_2126: actions.ReloadSlickgridAction;
    evh_6705964765214521_close_2125: actions.EventHandlerImpl;
    act_6705964765214521_showModal_2124: actions.ShowModalAction;
    evh_6705964765214521_click_2123: actions.EventHandlerImpl;
    evh_6705964765214521_click: actions.EventHandlerGroup;
    act_6806515264385235_reloadSlickgrid_2130: actions.ReloadSlickgridAction;
    evh_6806515264385235_close_2129: actions.EventHandlerImpl;
    act_6806515264385235_showModal_2128: actions.ShowModalAction;
    evh_6806515264385235_click_2127: actions.EventHandlerImpl;
    evh_6806515264385235_click: actions.EventHandlerGroup;
    act_8116269939469002_reloadSlickgrid_2134: actions.ReloadSlickgridAction;
    evh_8116269939469002_success_2133: actions.EventHandlerImpl;
    act_8116269939469002_request_2132: actions.RequestAction;
    evh_8116269939469002_click_2131: actions.EventHandlerImpl;
    evh_8116269939469002_click: actions.EventHandlerGroup;
    act_5900129514656303_reloadSlickgrid_2138: actions.ReloadSlickgridAction;
    evh_5900129514656303_close_2137: actions.EventHandlerImpl;
    act_5900129514656303_showModal_2136: actions.ShowModalAction;
    evh_5900129514656303_click_2135: actions.EventHandlerImpl;
    evh_5900129514656303_click: actions.EventHandlerGroup;
    act_3343864469950044_reloadSlickgrid_2140: actions.ReloadSlickgridAction;
    evh_3343864469950044_success_2139: actions.EventHandlerImpl;
    evh_3343864469950044_success: actions.EventHandlerGroup;
    act_1889980785424776_reloadSlickgrid_2144: actions.ReloadSlickgridAction;
    evh_1889980785424776_success_2143: actions.EventHandlerImpl;
    act_1889980785424776_request_2142: actions.RequestAction;
    evh_1889980785424776_click_2141: actions.EventHandlerImpl;
    evh_1889980785424776_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_setData_2112 = new actions.SetDataAction(
      {
        actionArgs: this.act_7315092382398562_setData_2112_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_selectedRowsChanged_2111 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_setData_2112,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_7315092382398562_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_selectedRowsChanged_2111],
      }
    );
    const act_7315092382398562_showModal_2114 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7315092382398562_showModal_2114_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_command_2113 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_showModal_2114,
        event: "command",
        when: this.evh_7315092382398562_command_2113_getWhen,
        displayName: "showModal",
      }
    );
    const act_7315092382398562_reloadSlickgrid_2118 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_7315092382398562_reloadSlickgrid_2118_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2117 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadSlickgrid_2118,
        event: "close",
        when: this.evh_7315092382398562_close_2117_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_7315092382398562_showModal_2116 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7315092382398562_showModal_2116_getActionArgs,
        events: [evh_7315092382398562_close_2117],
      }
    );
    const evh_7315092382398562_command_2115 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_showModal_2116,
        event: "command",
        when: this.evh_7315092382398562_command_2115_getWhen,
        displayName: "showModal",
      }
    );
    const evh_7315092382398562_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_command_2113, evh_7315092382398562_command_2115],
      }
    );
    const act_8320016629450276_reloadSlickgrid_2122 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8320016629450276_reloadSlickgrid_2122_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_close_2121 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadSlickgrid_2122,
        event: "close",
        when: this.evh_8320016629450276_close_2121_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_8320016629450276_showModal_2120 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_2120_getActionArgs,
        events: [evh_8320016629450276_close_2121],
      }
    );
    const evh_8320016629450276_click_2119 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_2120,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_2119],
      }
    );
    const act_6705964765214521_reloadSlickgrid_2126 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6705964765214521_reloadSlickgrid_2126_getActionArgs,
        events: [],
      }
    );
    const evh_6705964765214521_close_2125 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_reloadSlickgrid_2126,
        event: "close",
        when: this.evh_6705964765214521_close_2125_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_6705964765214521_showModal_2124 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6705964765214521_showModal_2124_getActionArgs,
        events: [evh_6705964765214521_close_2125],
      }
    );
    const evh_6705964765214521_click_2123 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_showModal_2124,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6705964765214521_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_click_2123],
      }
    );
    const act_6806515264385235_reloadSlickgrid_2130 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6806515264385235_reloadSlickgrid_2130_getActionArgs,
        events: [],
      }
    );
    const evh_6806515264385235_close_2129 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_reloadSlickgrid_2130,
        event: "close",
        when: this.evh_6806515264385235_close_2129_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_6806515264385235_showModal_2128 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6806515264385235_showModal_2128_getActionArgs,
        events: [evh_6806515264385235_close_2129],
      }
    );
    const evh_6806515264385235_click_2127 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_showModal_2128,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6806515264385235_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6806515264385235_click_2127],
      }
    );
    const act_8116269939469002_reloadSlickgrid_2134 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8116269939469002_reloadSlickgrid_2134_getActionArgs,
        events: [],
      }
    );
    const evh_8116269939469002_success_2133 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_reloadSlickgrid_2134,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8116269939469002_request_2132 = new actions.RequestAction(
      {
        actionArgs: this.act_8116269939469002_request_2132_getActionArgs,
        displayName: "deleteItems",
        events: [evh_8116269939469002_success_2133],
      }
    );
    const evh_8116269939469002_click_2131 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_request_2132,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_8116269939469002_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8116269939469002_click_2131],
      }
    );
    const act_5900129514656303_reloadSlickgrid_2138 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_5900129514656303_reloadSlickgrid_2138_getActionArgs,
        events: [],
      }
    );
    const evh_5900129514656303_close_2137 = new actions.EventHandlerImpl(
      {
        action: act_5900129514656303_reloadSlickgrid_2138,
        event: "close",
        when: this.evh_5900129514656303_close_2137_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_5900129514656303_showModal_2136 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5900129514656303_showModal_2136_getActionArgs,
        events: [evh_5900129514656303_close_2137],
      }
    );
    const evh_5900129514656303_click_2135 = new actions.EventHandlerImpl(
      {
        action: act_5900129514656303_showModal_2136,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_5900129514656303_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_5900129514656303_click_2135],
      }
    );
    const act_3343864469950044_reloadSlickgrid_2140 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3343864469950044_reloadSlickgrid_2140_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_success_2139 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_reloadSlickgrid_2140,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_3343864469950044_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_success_2139],
      }
    );
    const act_1889980785424776_reloadSlickgrid_2144 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1889980785424776_reloadSlickgrid_2144_getActionArgs,
        events: [],
      }
    );
    const evh_1889980785424776_success_2143 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_reloadSlickgrid_2144,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1889980785424776_request_2142 = new actions.RequestAction(
      {
        actionArgs: this.act_1889980785424776_request_2142_getActionArgs,
        displayName: "deleteInvoices",
        events: [evh_1889980785424776_success_2143],
      }
    );
    const evh_1889980785424776_click_2141 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_request_2142,
        event: "click",
        displayName: "deleteInvoices",
      }
    );
    const evh_1889980785424776_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_1889980785424776_click_2141],
      }
    );
    return {
      act_7315092382398562_setData_2112,
      evh_7315092382398562_selectedRowsChanged_2111,
      evh_7315092382398562_selectedRowsChanged,
      act_7315092382398562_showModal_2114,
      evh_7315092382398562_command_2113,
      act_7315092382398562_reloadSlickgrid_2118,
      evh_7315092382398562_close_2117,
      act_7315092382398562_showModal_2116,
      evh_7315092382398562_command_2115,
      evh_7315092382398562_command,
      act_8320016629450276_reloadSlickgrid_2122,
      evh_8320016629450276_close_2121,
      act_8320016629450276_showModal_2120,
      evh_8320016629450276_click_2119,
      evh_8320016629450276_click,
      act_6705964765214521_reloadSlickgrid_2126,
      evh_6705964765214521_close_2125,
      act_6705964765214521_showModal_2124,
      evh_6705964765214521_click_2123,
      evh_6705964765214521_click,
      act_6806515264385235_reloadSlickgrid_2130,
      evh_6806515264385235_close_2129,
      act_6806515264385235_showModal_2128,
      evh_6806515264385235_click_2127,
      evh_6806515264385235_click,
      act_8116269939469002_reloadSlickgrid_2134,
      evh_8116269939469002_success_2133,
      act_8116269939469002_request_2132,
      evh_8116269939469002_click_2131,
      evh_8116269939469002_click,
      act_5900129514656303_reloadSlickgrid_2138,
      evh_5900129514656303_close_2137,
      act_5900129514656303_showModal_2136,
      evh_5900129514656303_click_2135,
      evh_5900129514656303_click,
      act_3343864469950044_reloadSlickgrid_2140,
      evh_3343864469950044_success_2139,
      evh_3343864469950044_success,
      act_1889980785424776_reloadSlickgrid_2144,
      evh_1889980785424776_success_2143,
      act_1889980785424776_request_2142,
      evh_1889980785424776_click_2141,
      evh_1889980785424776_click,
      deleteItems: act_8116269939469002_request_2132,
      deleteInvoices: act_1889980785424776_request_2142,
    }
  }
}

Vue.component("UcBillingList", UcBillingList);

</script>